import type { HelpFile } from '../../types/help'
import { RestrictionRuleRequestEditTestIds } from '../../../testids/RestrictionRuleRequestEditTestIds'

export const restrictionRuleRequestEditHelp: HelpFile = {
  docPage: '/docs/governance/restriction-rules',
  texts: {
    [RestrictionRuleRequestEditTestIds.restrictionRuleRequestEditPage]: 'Einen Entwurf eines Antrags zur Änderung einer Beschränkungsregel bearbeiten — Ausdruck, gesperrte Zugriffsprofile und Genehmiger vor dem Einreichen anpassen.',
    [RestrictionRuleRequestEditTestIds.btnBackNotEditable]: 'Zur Antragsdetailansicht zurückkehren. Der Antrag kann im aktuellen Status nicht mehr bearbeitet werden.',
  },
}
